import React, { useContext, useEffect, useState } from 'react';
import { Layout } from 'antd/lib';
import Sidebar from '../Sidebar/index';
import HorizontalDefault from '../Topbar/HorizontalDefault/index';
import HorizontalDark from '../Topbar/HorizontalDark/index';
import InsideHeader from '../Topbar/InsideHeader/index';
import AboveHeader from '../Topbar/AboveHeader/index';
import BelowHeader from '../Topbar/BelowHeader/index';
import Topbar from '../Topbar/index';
import App from '../../routes/index';
import { useSelector } from 'react-redux';
import { ThemeSetting } from '../../constants/ThemeSetting';
import NoHeaderNotification from '../Topbar/NoHeaderNotification/index';
import { useRouteMatch } from 'react-router-dom';
// Auth Context
import CustomizerSystem from '../Customizer';
import IntlMessages from '../../util/IntlMessages';

const { Content, Footer } = Layout;
const {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
} = ThemeSetting;

const MainApp = (props: any) => {
  const { width, navStyle, locale } = useSelector(
    ({ settings }: any) => settings,
  );

  const match = useRouteMatch();

  const getContainerClass = (navStyle: string) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-container-wrap';
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-container-wrap';
      default:
        return '';
    }
  };

  const getNavStyles = (navStyle: string) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  const getSidebar = (navStyle: string, width: number) => {
    if (width < +TAB_SIZE) {
      return <Sidebar />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />;
      case NAV_STYLE_DRAWER:
        return <Sidebar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />;
      default:
        return null;
    }
  };

  //  style={{ direction: locale.direction }}

  return (
    <React.Fragment>
      <Layout className="gx-app-layout" dir={locale.direction}>
        {getSidebar(navStyle, width)}

        <Layout>
          {getNavStyles(navStyle)}
          <Content
            className={`gx-layout-content ${getContainerClass(navStyle)} `}
          >
            <App match={match} />
            <Footer
              style={{
                zIndex: 100,
                overflow: 'hidden',
                textAlign: 'left',
                direction: 'ltr',
                fontFamily: 'sans-serif',
              }}
              className="gx-position-absolute gx-bottom-0 gx-w-100 gx-p-0"
            >
              <div
                // className=" gx-layout-footer-content gx-align-center"
                className="gx-w-100 gx-py-2 gx-bg-primary"
                style={{ overflow: 'hidden' }}
              >
                <span className="gx-px-2 gx-text-white gx-fs-xs">
                  ©{new Date().getUTCFullYear()}
                </span>
                <a
                  className="gx-text-secondary justify-content-lg-around gx-fs-xs"
                  href="https://www.faragostar.net"
                  target="_blank"
                  style={{ fontSize: '10px' }}
                  rel="noreferrer"
                >
                  FaraGostar
                </a>
              </div>
            </Footer>
          </Content>
        </Layout>
        <CustomizerSystem />
      </Layout>
    </React.Fragment>
  );
};

export default MainApp;
